import React from 'react'
import "./GalleryCard.css"


const GalleryCard = (props) => {
    return (
        <div>
            <div className='glass'>
                <div className="fake"></div>
                <article key={props.id} className='proto__item'>
                    <div className='item-img-container'>
                        <div className="proto__item-img">
                            <img src={props.image} alt={props.title} />
                        </div>
                        <div className='item-date'>
                            <h1 className='year'>- {props.year}</h1>
                            <h1>{props.month}</h1>
                        </div>
                    </div>
                    <div className='proto__item-info'>
                        <h3>{props.title}</h3>
                        <p>{props.desc}</p>
                        <div className='proto__item-cta'>
                            <a href={props.link} className='btn' target="_blank" rel='noreferrer'>Live</a>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    )
}

export default GalleryCard
